export class MyVoucherDM {
  constructor({
    created_at = "",
    evoucher = "",
    evoucher_valid_until = "",
    expired_date = "",
    is_expired = false,
    is_url = false,
    is_used = false,
    redemption = {},
    reward = {},
    status = "",
    used_validation_type = "",
    user = "",
    voucher = "",
  }) {
    this.created_at = created_at;
    this.evoucher = evoucher;
    this.evoucher_valid_until = evoucher_valid_until;
    this.expired_date = expired_date;
    this.is_expired = is_expired;
    this.is_url = is_url;
    this.is_used = is_used;
    this.redemption = redemption;
    this.reward = reward;
    this.status = status;
    this.used_validation_type = used_validation_type;
    this.user = user;
    this.voucher = voucher;
  }

  toJson() {
    return {
      created_at: this.created_at,
      evoucher: this.evoucher,
      evoucher_valid_until: this.evoucher_valid_until,
      expired_date: this.expired_date,
      is_expired: this.is_expired,
      is_url: this.is_url,
      is_used: this.is_used,
      redemption: this.redemption,
      reward: this.reward,
      status: this.status,
      used_validation_type: this.used_validation_type,
      user: this.user,
      voucher: this.voucher,
    };
  }

  static fromJson(json) {
    return new MyVoucherDM({
      created_at: json["created_at"],
      additional_info: json["additional_info"],
      evoucher: json["evoucher"],
      evoucher_valid_until: json["evoucher_valid_until"],
      expired_date: json["expired_date"],
      is_expired: json["is_expired"],
      is_url: json["is_url"],
      is_used: json["is_used"],
      redemption: json["redemption"],
      reward: json["reward"],
      status: json["status"],
      used_validation_type: json["used_validation_type"],
      user: json["user"],
      voucher: json["voucher"],
    });
  }
}
